/**
 * "Gå hit" point picking (spec 13) — two entry points converge here:
 *  1. Long-press on the map (Leaflet `contextmenu`, fires on touch long-press
 *     on most browsers) proposes a point directly.
 *  2. "Velg i kartet" in the search sheet — the documented fallback for
 *     devices where long-press doesn't fire reliably (verify per device;
 *     never assume). Arms pick mode; the next map tap proposes the point.
 * Either way the result is a `candidate` awaiting confirmation in
 * PickPointSheet — a stray tap/long-press should never silently move the pin.
 */
import { create } from 'zustand';

interface PickPointState {
  pickModeActive: boolean;
  candidate: { lat: number; lon: number } | null;
  startPickMode: () => void;
  cancelPickMode: () => void;
  proposePoint: (lat: number, lon: number) => void;
  clearCandidate: () => void;
}

export const usePickPointStore = create<PickPointState>((set) => ({
  pickModeActive: false,
  candidate: null,
  startPickMode: () => set({ pickModeActive: true, candidate: null }),
  cancelPickMode: () => set({ pickModeActive: false }),
  proposePoint: (lat, lon) => set({ pickModeActive: false, candidate: { lat, lon } }),
  clearCandidate: () => set({ candidate: null }),
}));
